import script from "./invoice.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice.vue?vue&type=script&setup=true&lang=js"

import "./invoice.vue?vue&type=style&index=0&id=7ee88ca0&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee88ca0"]])

export default __exports__